import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks"
import { Dialog } from "primereact/dialog";
import { useCallback, useState } from "react";
import { Button } from "primereact/button";
import { generateNotableItems } from "../../services/defectService";
import { selectGenerateItemsDialog, selectInspectionData } from "../../store/selectors/inspectionSelectors";
import { setShowGeneratedItemsDialog } from "../../store/slices/inspectionSlice";
import { useAuthenticator } from "@aws-amplify/ui-react";

export const GenerateItemsDialog = () => {
    const dispatch = useAppDispatch();

    const showDialog = useAppSelector(selectGenerateItemsDialog);

    const { user } = useAuthenticator((context) => [context.user]);
    const inspection = useAppSelector(selectInspectionData);
    const [loading, setLoading] = useState(false);

    const onHide = () => {
        dispatch(setShowGeneratedItemsDialog(false));
    };

    const onGenerate = useCallback(async () => {
        setLoading(true);

        await generateNotableItems(inspection, user);

        setLoading(false);
        onHide()
    }, []);

    const footerContent = () => (
        <div className="flex justify-content-end">
            <Button label="Cancel" onClick={onHide} disabled={loading} data-cy="cancel-generate-button"/>
            <Button label={loading ? undefined : "Generate"} icon={loading ? "pi pi-spin pi-spinner" : undefined} onClick={onGenerate} disabled={loading} data-cy="confirm-generate-button"/>
        </div>
    );

    return (
        <Dialog header="Generate Notable Items?" visible={showDialog} className="small-dialog" draggable={false} onHide={onHide} footer={footerContent} data-cy="generate-dialog">
            <p>Do you want to generate notable items?</p>
        </Dialog>
    )
}